import { render, staticRenderFns } from "./CaregivingDeck.vue?vue&type=template&id=fc132424"
import script from "./CaregivingDeck.vue?vue&type=script&lang=js"
export * from "./CaregivingDeck.vue?vue&type=script&lang=js"
import style0 from "./CaregivingDeck.vue?vue&type=style&index=0&id=fc132424&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports